import { render, staticRenderFns } from "./codeTest.vue?vue&type=template&id=00083fe3&scoped=true"
import script from "./codeTest.vue?vue&type=script&lang=js"
export * from "./codeTest.vue?vue&type=script&lang=js"
import style0 from "./codeTest.vue?vue&type=style&index=0&id=00083fe3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00083fe3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00083fe3')) {
      api.createRecord('00083fe3', component.options)
    } else {
      api.reload('00083fe3', component.options)
    }
    module.hot.accept("./codeTest.vue?vue&type=template&id=00083fe3&scoped=true", function () {
      api.rerender('00083fe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/codeTest.vue"
export default component.exports